import { useEffect } from "react";
import api from "@/lib/api";
import { setCachedTimezone } from "@/lib/dateUtils";

export const FONT_PRESETS = {
  roboto_condensed: {
    label: "Bold Condensed (Roboto Condensed + Outfit)",
    heading: "Roboto Condensed",
    body: "Outfit",
    googleFontUrl: "https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@400;500;600;700;800&family=Outfit:wght@300;400;500;600;700&display=swap",
  },
  jakarta_pro: {
    label: "Jakarta Pro (Plus Jakarta Sans + Outfit)",
    heading: "Plus Jakarta Sans",
    body: "Outfit",
    googleFontUrl: "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;600;700;800&family=Outfit:wght@300;400;500;600;700&display=swap",
  },
  times_classic: {
    label: "Times Classic (Times New Roman + Outfit)",
    heading: "Times New Roman",
    body: "Outfit",
    googleFontUrl: "https://fonts.googleapis.com/css2?family=Tinos:wght@400;700&family=Outfit:wght@300;400;500;600;700&display=swap",
  },
  premium_readable: {
    label: "Premium Readable (Playfair Display + Outfit)",
    heading: "Playfair Display",
    body: "Outfit",
    googleFontUrl: "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700;800&family=Outfit:wght@300;400;500;600;700&display=swap",
  },
  classic_luxury: {
    label: "Classic Luxury (Cormorant Garamond + Outfit)",
    heading: "Cormorant Garamond",
    body: "Outfit",
    googleFontUrl: "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=Outfit:wght@300;400;500;600;700&display=swap",
  },
  modern_elegant: {
    label: "Modern Elegant (Playfair Display + Manrope)",
    heading: "Playfair Display",
    body: "Manrope",
    googleFontUrl: "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800&family=Manrope:wght@300;400;500;600;700&display=swap",
  },
  bold_editorial: {
    label: "Bold Editorial (Fraunces + Work Sans)",
    heading: "Fraunces",
    body: "Work Sans",
    googleFontUrl: "https://fonts.googleapis.com/css2?family=Fraunces:wght@400;500;600;700;800&family=Work+Sans:wght@300;400;500;600;700&display=swap",
  },
  minimal_premium: {
    label: "Minimal Premium (Libre Baskerville + Inter)",
    heading: "Libre Baskerville",
    body: "Inter",
    googleFontUrl: "https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=Inter:wght@300;400;500;600;700&display=swap",
  },
};

let loadedFontUrls = new Set();

function loadGoogleFont(url) {
  if (loadedFontUrls.has(url)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = url;
  document.head.appendChild(link);
  loadedFontUrls.add(url);
}

export function setFavicon(url) {
  if (!url) return;
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = url;
}

export default function ThemeLoader() {
  useEffect(() => {
    api.get("/site-settings").then((res) => {
      const settings = res.data;
      const root = document.documentElement;
      if (settings.theme_primary_color) root.style.setProperty("--brand-primary", settings.theme_primary_color);
      if (settings.theme_secondary_color) root.style.setProperty("--brand-secondary", settings.theme_secondary_color);
      const preset = FONT_PRESETS[settings.theme_font_preset] || FONT_PRESETS.roboto_condensed;
      loadGoogleFont(preset.googleFontUrl);
      root.style.setProperty("--font-heading", `"${preset.heading}"`);
      root.style.setProperty("--font-body", `"${preset.body}"`);
      if (settings.timezone) setCachedTimezone(settings.timezone);
      if (settings.favicon_url) setFavicon(settings.favicon_url);
    }).catch(() => {});
  }, []);

  return null;
}
